import React, { useContext, useEffect, useRef, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { generateDownload, getTaskDetail } from '../../../utils/net';
import {
    logInfoAtom,
    regenePrivateSetAtom,
    showLoginAtom,
    showPayCardAtom,
    showRegenerateAtom,
    taskDetailAtom,
    isPurchasedAtom,
    packInfoAtom,
    userPermissionAtom,
    openPaymentInfoAtom,
    modalObjAtom,
    subscriptionsInfoAtom,
    balanceAtom,
} from '../../../store';
import style from './bundlePanelFade.module.css';
import walletIcon from '../../../assets/wallet.png';
import groupWalletIcon from '../../../assets/groupWallet.png';
import finishIconSrc from '../../../assets/finish.png';
import { qualityArr, topologyArr, AdditionalArr } from '../../../utils/map'
import { useRefreshInfo } from '../../../utils/hooks';
import { driver } from 'driver.js';
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import { Turnstile } from "@marsidev/react-turnstile";
import { handleCaptchaVerification } from "../../../utils/auth";
import { PermissionContext } from "../../../utils/context";


function BundlePanelFade({ onLikeChange }) {
    const balance = useRecoilValue(balanceAtom);
    const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
    const [openPaymentInfo, setOpenPaymentInfo] = useRecoilState(openPaymentInfoAtom)
    const [step, setStep] = useState(2);
    const userPermission = useRecoilValue(userPermissionAtom)
    const [qualityIndex, setQualityIndex] = useState(0);
    const [topologyIndex, setTopologyIndex] = useState(0);
    const [additional, setAdditional] = useState([]);
    const [bodyOpt, setBodyOpt] = useState({ gender: 2 });
    const setRegenePrivate = useSetRecoilState(regenePrivateSetAtom);
    const [packInfo, setPackInfo] = useRecoilState(packInfoAtom);
    const [modalObj, setModalObj] = useRecoilState(modalObjAtom);
    const [taskDetail, setTaskDetail] = useRecoilState(taskDetailAtom);
    const logInfo = useRecoilValue(logInfoAtom);
    const setShowLogin = useSetRecoilState(showLoginAtom);
    const setIsPurchased = useSetRecoilState(isPurchasedAtom);
    const setShowRegenerate = useSetRecoilState(showRegenerateAtom);
    const [autoParams, setAutoParams] = useState(0);
    const setShowPayCard = useSetRecoilState(showPayCardAtom);
    const { t } = useTranslation();
    const { refreshInfo } = useRefreshInfo()
    const base_addtionalArr = taskDetail?.settings?.caption_style ? AdditionalArr.filter((i) => i.index === 3) : AdditionalArr
    const extra_addtionalArr = userPermission.chatavatar_allowed_additional_process
    const extra_topology = taskDetail?.group?.settings?.allowed_topology.filter((item) => item !== "Daz3d")
    const turnstileRef = useRef()
    const { isAllowedTo } = useContext(PermissionContext);

    useEffect(() => {
        return () => {
            setTopologyIndex(0);
            setAdditional([]);
            setQualityIndex(0);
            setStep(2);
        };
    }, []);


    useEffect(() => {
        if (topologyIndex >= topologyArr.length - 1) {
            setAdditional([])
        }
    }, [topologyIndex])

    const driverGuide = (balance) => {
        setModalObj({ ...modalObj, state: false });
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setOpenPaymentInfo({
            ...openPaymentInfo,
            state: true,
            group: taskDetail?.group,
            balance: balance,
            step: 1
        })

        const driverObj = new driver({
            overlayColor: 'rgba(0,0,0,0.6)',
        });
        const target = taskDetail?.group ? "#rechargeGroup #rechargePopup" : "#rechargeSelf #rechargePopup"
        driverObj.highlight({
            element: target,
            popover: {
                title: t('DRIVEROBJ_BALANCE_TITLE'),
                description: t('DRIVEROBJ_BALANCE_DESC'),
                popoverClass: "rechargedriver"
            }
        });
        if (document.querySelector(target)) {
            document.querySelector(target).addEventListener("click", () => {
                driverObj.destroy();
            });
        }
    }
    const handlePay = async () => {
        if (!logInfo) {
            setShowLogin(true);
            return;
        }
        if ((balance.selfBalance + subscriptionsInfo.wallet_balance) / 10 < totalCost) {
            driverGuide(totalCost - (balance.selfBalance + subscriptionsInfo.wallet_balance) / 10)
            return;
        }

        try {
            const req = {
                task_uuid: taskDetail.task_uuid,
                resolution: qualityArr[qualityIndex].resolution,
                topology: topologyIndex > topologyArr.length - 1 ? extra_topology[topologyIndex - 2] : topologyArr[topologyIndex].topology,
            };
            if (additional.length) {
                req.additional = additional.map((opt) => AdditionalArr[opt].option);
            }

            if (topologyIndex === 0 && additional.includes(0)) {
                req.settings = {
                    height: Number(bodyOpt.height),
                    weight: Number(bodyOpt.weight),
                    gender: bodyOpt.gender === 1,
                };
            }

            const captchaToken = await handleCaptchaVerification(turnstileRef, isAllowedTo('captcha.feature'))

            const res = await generateDownload(req, captchaToken);
            if (res.data.error) throw new Error(res.data.error);
            setShowRegenerate(false);
            setRegenePrivate({
                oldPrivate: '',
                currentPrivate: '',
                privatedChange: '',
            });
            const response = await getTaskDetail(taskDetail.task_uuid);
            setTaskDetail(response.data);
            setPackInfo({
                ...packInfo,
                isPaid: true,
                details: response.data
            })
            await onLikeChange(null, true)
            setIsPurchased(true)
            refreshInfo()
        } catch (e) {
            Sentry.captureException(e)
        }
    };

    const handleBack = () => {
        if (!logInfo) {
            setShowLogin(true);
            return;
        }
        if (step === 0) setStep(2);
        else if (step === 1) {
            setStep(0);
        } else if (step === 2) {
            setShowPayCard(false);
        }
    };

    const handleAdditionalClick = (opt) => () => {
        additional.includes(opt)
            ? setAdditional(additional.filter((cur) => cur !== opt))
            : setAdditional([...additional, opt]);
    };

    const totalCost = qualityArr[qualityIndex].credits + topologyArr[topologyIndex >= topologyArr.length ? 1 : topologyIndex].credits + additional.length * 1

    const handlersetTopologyIndex = (index) => setTopologyIndex(index)

    const handlerCheckBodyOpt = (index) => setBodyOpt({ ...bodyOpt, gender: index })

    const handlerToggleAuto = (index) => {
        if (index === 0) {
            setBodyOpt({ ...bodyOpt, weight: null, height: null });
        }
        setAutoParams(index);
    }

    const handlerSetQualityIndex = (index) => setQualityIndex(index)

    const handlerSetStep = (step) => {
        setStep(step)
    }


    return (
        <div className={style.downloadCon}>
            {/* 2 first  0 second  1 three */}
            {!packInfo.isPaid && (
                <>
                    <div
                        className={`${style.stepOneBox} ${step === 2 && style.fadeInOne} ${(step === 0 || step === 1) && style.fadeOutOne}`}
                    >
                        <div className={style.downloadTitle}>
                            <div>{t('CHATAVATAR_GENERTAE_BOARD_TITLE_1')}</div>
                            <div className={style.backBtn} onPointerDown={handleBack}>
                                {'< '}
                                {t('CHATAVATAR_GENERTAE_BOARD_TITLE_2')}
                            </div>
                        </div>
                        {/* 2k  */}
                        {qualityArr.map((item, index) => {
                            return <div
                                key={index + item.name}
                                className={`${style.row} ${qualityIndex === index ? style.selected : ''
                                    }`}
                                onClick={handlerSetQualityIndex.bind(null, index)}
                            >
                                <div className={style.priceCon}>
                                    <img className={style.icon} src={walletIcon} alt="wallet" />
                                    <div className={style.price}>{item.credits}</div>
                                </div>
                                <div className={style.option}>{item.name}</div>
                            </div>
                        })}
                        <div className={style.costCon}>
                            Payment amount:
                            {' '}
                            <span>{totalCost}</span>
                        </div>
                        <div
                            className={style.downloadBtn}
                            onClick={handlerSetStep.bind(null, 0)}
                        >
                            {t('BUTTON_NEXT')}
                        </div>
                    </div>
                    <div
                        className={`${style.stepTwoBox}  ${step === 0 && style.fadeInTwo} ${step === 1 && style.fadeOutTwo}`}
                    >
                        <div className={style.downloadTitle}>
                            <div>{t('CHATAVATAR_GENERTAE_BOARD_TITLE_1')}</div>
                            <div className={style.backBtn} onPointerDown={handleBack}>
                                {'< '}
                                {t('CHATAVATAR_GENERTAE_BOARD_TITLE_2')}
                            </div>
                        </div>

                        {(extra_topology ? [...topologyArr, ...extra_topology.map((item) => {
                            return {
                                name: item,
                                topology: 'MetaHuman',
                                subscript: 'Group',
                                credits: 4
                            }
                        })] : topologyArr).map((item, index) => {
                            return <div
                                key={index + item.name}
                                className={`${style.row} ${topologyIndex === index ? style.selected : ''}`}
                                onClick={handlersetTopologyIndex.bind(null, index)}
                            >
                                <div className={`${style.priceCon}  ${index > topologyArr.length - 1 ? style.groupIcon : ''}`}>
                                    <img className={style.icon} src={index > topologyArr.length - 1 ? groupWalletIcon : walletIcon} alt="wallet" />
                                    <div className={style.price}>{item.credits}</div>
                                </div>
                                <div className={style.option}>{item.name === "PerfectWorld" ? "PNW-fat" : item.name}</div>
                                {index === 0 && <div className={`${style.corner} ${style.sec}`}>{item.subscript}</div>}
                                {index > topologyArr.length - 1 && <div className={`${style.corner} ${style.groupMeta}`}>{item.subscript}</div>}

                            </div>
                        })}
                        <div className={style.costCon}>
                            Payment amount:
                            {' '}
                            <span>{totalCost}</span>
                        </div>
                        {topologyIndex === 0 || (topologyIndex > topologyArr.length - 1 && extra_addtionalArr) ? (
                            <div
                                className={style.downloadBtn}
                                onClick={handlerSetStep.bind(null, 1)}
                            >
                                {t('BUTTON_NEXT')}
                            </div>
                        ) : (
                            <div
                                className={style.downloadBtn}
                                onClick={handlePay}
                            >
                                {t('BUTTON_PAY')}

                            </div>
                        )}
                    </div>

                    <div className={`${style.stepThreeBox}  ${step === 1 && style.fadeInThree}`}>
                        <div className={style.downloadTitle}>
                            <div>Export Options</div>
                            <div className={style.backBtn} onPointerDown={handleBack}>
                                {'< '}
                                Back
                            </div>
                        </div>
                        <div style={{ overflowY: 'auto', maxHeight: '20rem' }}>
                            {/* body */}
                            {((topologyIndex > topologyArr.length - 1 && extra_addtionalArr && extra_topology) ? base_addtionalArr.filter((item) => extra_addtionalArr[extra_topology[topologyIndex - 2]].includes(item.option)) : base_addtionalArr).map((item) => {
                                return <React.Fragment
                                    key={item.option}>
                                    <div
                                        className={`${style.row} ${additional.includes(base_addtionalArr.find(itm => itm.option === item.option).index) ? style.selected : ''}`}
                                        onPointerDown={handleAdditionalClick(base_addtionalArr.find(itm => itm.option === item.option).index)}
                                    >
                                        <div className={style.priceCon}>
                                            <img className={style.icon} src={walletIcon} alt="wallet" />
                                            <div className={style.price}>{item.credits}</div>
                                        </div>
                                        <div className={style.option}>{item.name}</div>
                                    </div>
                                    {
                                        base_addtionalArr.find(itm => itm.option === item.option).index === 0 && <div
                                            className={`${style.bodyOptCon} ${additional.includes(0) ? style.show : style.hide
                                                }`}
                                        >
                                            <div className={style.subRow}>
                                                {['Male', 'Female', 'Others'].map((item, index) => {
                                                    return <div
                                                        key={item}
                                                        className={`${style.genderBtn} ${bodyOpt.gender === index ? style.selected : ''
                                                            }`}
                                                        onClick={handlerCheckBodyOpt.bind(null, index)}
                                                    >
                                                        {item}
                                                    </div>
                                                })}
                                            </div>
                                            <div className={style.subRow}>
                                                {['Auto', 'Manual'].map((item, index) => {
                                                    return <div
                                                        key={item}
                                                        className={`${style.genderBtn} ${autoParams === index ? style.selected : ''
                                                            }`}
                                                        onClick={handlerToggleAuto.bind(null, index)}
                                                    >
                                                        {item}
                                                    </div>
                                                })}
                                            </div>
                                            <div>
                                                <div className={style.subRow}>
                                                    <div className={style.label}>Height</div>
                                                    <div className={style.inputCon}>
                                                        <input
                                                            type="range"
                                                            min="140"
                                                            max="220"
                                                            value={bodyOpt.height}
                                                            onChange={(ev) => setBodyOpt({
                                                                ...bodyOpt,
                                                                height: ev.currentTarget.value,
                                                            })}
                                                            className={style.slider}
                                                            disabled={autoParams === 0}
                                                        />
                                                        <div style={{ width: '4.4rem', fontSize: '14.5px' }}>
                                                            <span className={style.suffixHeight}>
                                                                {autoParams === 1
                                                                    ? bodyOpt.height
                                                                        ? `${bodyOpt.height} cm`
                                                                        : ' cm'
                                                                    : 'Auto'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className={style.subRow}>
                                                    <div className={style.label}>Weight</div>
                                                    <div className={style.inputCon}>
                                                        <input
                                                            type="range"
                                                            min="40"
                                                            max="110"
                                                            value={bodyOpt.weight}
                                                            onChange={(ev) => setBodyOpt({
                                                                ...bodyOpt,
                                                                weight: ev.currentTarget.value,
                                                            })}
                                                            className={style.slider}
                                                            disabled={autoParams === 0}
                                                        />
                                                        <div style={{ width: '4.4rem', fontSize: '14.5px' }}>
                                                            <span className={style.suffixWeight}>
                                                                {autoParams === 1
                                                                    ? bodyOpt.weight
                                                                        ? `${bodyOpt.weight} kg`
                                                                        : ' kg'
                                                                    : 'Auto'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </React.Fragment>
                            })}


                        </div>
                        <div className={style.costCon}>
                            Payment amount:
                            {' '}
                            <span>{totalCost}</span>
                        </div>
                        <div
                            className={style.downloadBtn}
                            onClick={handlePay}
                        >
                            {t('BUTTON_PAY')}
                        </div>
                    </div>
                </>
            )}

            {/* paid tips */}
            {packInfo.isPaid && !packInfo.isPackFinished ? (
                <div className={style.paidCon}>
                    <div>
                        <img className={style.paidIcon} src={finishIconSrc} alt="finish" />
                        <div className={style.paidTitle}>{t('CHATAVATAR_GENERTAE_BOARD_PAID_CON_TIPS_1')}!</div>
                        <div className={style.paidProgress}>
                            {t('CHATAVATAR_GENERTAE_BOARD_PAID_CON_TIPS_5')}...
                        </div>
                    </div>
                </div>
            ) : null}
            <Turnstile ref={turnstileRef} siteKey='0x4AAAAAAAhbdFXzdFzkoDOV'
                style={{ display: "none" }}
                options={{ appearance: 'interaction-only', execution: 'execute' }} />
        </div>
    );
}
BundlePanelFade.displayName = "BundlePanelFade"

export { BundlePanelFade };
